import React, { useState } from 'react';
import './LiveStream.scss';

type SportStatProps = {
  eventID: string;
};

const CricketLiveStream: React.FC<SportStatProps> = (props) => {
  const { eventID } = props;

  return (
    <div className="live-stream-ctn">
        <iframe
          title="mob-live-stream"
          allowFullScreen={false}
          src={`https://vid.dreamcasino.live/GetAPI.html?MatchID=${eventID?.split(':').join('_')}`}
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
    </div>
  );
};

export default CricketLiveStream;
